import { BankAccount } from "./entities/BankAccount";
import { Card } from "./entities/Card";
import { Customer } from "./entities/Customer";
import { Employee } from "./entities/Employee";
import { Invoice } from "./entities/Invoice";
import { Job } from "./entities/Job";
import { JobRequest } from "./entities/JobRequest";
import { Order } from "./entities/Order";
import { Payments } from "./entities/Payments";
import { Quote } from "./entities/Quote";
import { ServiceInvoice } from "./entities/ServiceInvoice";
import { Visit } from "./entities/Visit";
import { Subscription } from './entities/Subscription';
import { PaymentSubscriptions } from "./entities/PaymentSubscriptions";
import { OrganisationEmail } from "./entities/OrganisationEmail";
import { SystemEmail } from "./entities/SystemEmail";
import HelpTicket from "./entities/HelpTicket";
import Incident from './entities/Incident';
import {Note} from './entities/Note'
import { Task } from "./entities/Task";
import { Vehicle } from "./entities/Vehicle";
import { Organisation } from './entities/Organisation';
import { VehicleInvoice } from "./entities/VehicleInvoice";
import { Accident } from "./entities/Accident";
import { MaintenanceReport } from "./entities/MaintenanceReport";
import { Repair } from "./entities/Repair";
import { Alarm } from "./entities/Alarm";
import { Lead } from "./entities/Lead";
import { Vendor } from "./entities/Vendor";
import { QuickbooksIntegrationSettings } from "./entities/QuickbooksIntegrationSettings";
import { QuickbooksIntegrationHistory } from "./entities/QuickbooksIntegrationHistory";
import { QuickbooksIntegrationHistoryAdmin } from "./entities/QuickbooksIntegrationHistoryAdmin";
import { InvoiceItem } from "./entities/InvoiceItem";
import { InvoiceCategory } from "./entities/InvoiceCategory";
import { InformationSettings } from "./entities/Settings/InformationSettings";
import { BillingSettings } from "./entities/Settings/BillingSettings";
import { UsageSettings } from "./entities/Settings/UsageSettings";
import { CallingSettings } from "./entities/Settings/CallingSettings";
import { BusinessSettings } from "./entities/Settings/BusinessSettings";
import { IntegrationsList } from "./entities/Settings/IntegrationsList";
import { WebsiteBuilder } from "./entities/Settings/WebsiteBuilder";

export class CRUDFabric {

    static getClass(className) {
        className = className.toLowerCase();
        if (className.slice(-1) == 's') className = className.slice(0, -1);

        switch (className) {
            case 'request':      return JobRequest;
            case 'visit':        return Visit;
            case 'quote':        return Quote;
            case 'invoice':      return Invoice;
            case 'order':        return Order;
            case 'appointment':  return Order;
            case 'employee':     return Employee;
            case 'bank_account': return BankAccount;
            case 'card':         return Card;
            case 'customer':     return Customer;
            case 'job':          return Job;
            case 'payment':      return Payments;
            case 'service-invoice': return ServiceInvoice;
            case 'subscription': return Subscription;
            case 'payments-subscription': return PaymentSubscriptions;
            case 'email-campaign': return OrganisationEmail;
            case 'system-email': return SystemEmail;
            case 'incident':     return Incident;
            case 'help_ticket':  return HelpTicket;
            case 'help-ticket':  return HelpTicket;
            case 'note':         return Note;
            case 'task':         return Task;
            case 'vehicle':      return Vehicle;
            case 'organisation': return Organisation;
            case 'vehicle-invoice': return VehicleInvoice;
            case 'accident':     return Accident;
            case 'alarm':        return Alarm;
            case 'repair':  return Repair;
            case 'maintenance-report':  return MaintenanceReport;
            case 'lead':         return Lead;
            case 'vendor':       return Vendor;
            case 'quickbooks-settings': return QuickbooksIntegrationSettings;
            case 'quickbooks-sync-historie': return QuickbooksIntegrationHistory;
            case 'quickbooks-sync-admin-historie': return QuickbooksIntegrationHistoryAdmin;
            case 'item':         return InvoiceItem;
            case 'category':     return InvoiceCategory;
            case 'information-setting': return InformationSettings;
            case 'billing-setting': return BillingSettings;
            case 'usage-setting': return UsageSettings;
            case 'call-setting': return CallingSettings;
            case 'business-setting': return BusinessSettings;
            case 'integrations-list': return IntegrationsList;
            case 'website-builder': return WebsiteBuilder;
        }
    }

    static getObject(className, id) {
        const entityClass = CRUDFabric.getClass(className);
        return entityClass ? new entityClass(id) : undefined;
    }
}
